// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-453ce889] .compact-control {\n  padding-bottom: 5px;\n  padding-top: 8px;\n  padding-left: 2px;\n  height: 1.5rem;\n}\n\n/* Info-icon append: drop the grey input-group-text box so the icon floats\n   cleanly next to the field. */\n[data-v-453ce889] .info-append {\n  background-color: transparent;\n  border: none;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
